// Helpers that turn free-text product fields into comparable numbers.
const num = (s) => {
  const m = String(s || "").match(/(\d+(?:\.\d+)?)\s*%/);
  return m ? parseFloat(m[1]) : null;
};

export function annualRate(str) {
  const n = num(str);
  if (n == null) return null;
  const s = String(str).toLowerCase();
  if (/day/.test(s)) return n * 365;
  if (/month|p\.m/.test(s)) return n * 12;
  return n;
}

export function rateParts(str) {
  const s = String(str || "").trim();
  const m = s.match(/(\d+(?:\.\d+)?\s*%)/);
  if (!m) return { value: s || "—", unit: "" };
  const after = s.slice(s.indexOf(m[1]) + m[1].length).replace(/^[\s–-]*\d+(?:\.\d+)?\s*%/, "").trim();
  return { value: m[1].replace(/\s/g, ""), unit: after || "" };
}

export function maxTenureMonths(str) {
  const s = String(str || "").toLowerCase();
  const nums = (s.match(/\d+/g) || []).map(Number);
  if (!nums.length) return null;
  const n = Math.max(...nums);
  if (/day/.test(s)) return Math.max(1, Math.round(n / 30));
  if (/year/.test(s)) return n * 12;
  return n;
}

export function fmtINR(n) {
  return "₹" + Math.round(n || 0).toLocaleString("en-IN");
}

export function fmtLakh(n) {
  if (!n) return "—";
  if (n >= 10_000_000) return `₹${+(n / 10_000_000).toFixed(2)} Cr`;
  if (n >= 100_000) return `₹${+(n / 100_000).toFixed(2)} Lakh`;
  return fmtINR(n);
}

export function calcEmi(principal, ratePa, months) {
  const r = ratePa / 12 / 100;
  if (!principal || !months) return { emi: 0, interest: 0, total: 0 };
  const emi = r === 0 ? principal / months : (principal * r * (1 + r) ** months) / ((1 + r) ** months - 1);
  const total = emi * months;
  return { emi, interest: total - principal, total };
}

export function sortByRate(products) {
  return [...products].sort((a, b) => (annualRate(a.interest_rate) ?? 1e9) - (annualRate(b.interest_rate) ?? 1e9));
}

export function summarise(products) {
  const best = sortByRate(products)[0];
  const maxAmount = Math.max(0, ...products.map((p) => p.loan_max || 0));
  const maxTenure = Math.max(0, ...products.map((p) => maxTenureMonths(p.tenure) || 0));
  return { bestRate: best?.interest_rate || "", maxAmount, maxTenure };
}

export function bestForAmount(products, amount) {
  const fit = products.filter((p) => (p.loan_min == null || amount >= p.loan_min) && (p.loan_max == null || amount <= p.loan_max));
  return sortByRate(fit.length ? fit : products)[0] || null;
}
